(function () {
    'use strict';


    angular
        .module('trainingDiscrepancy')
        .factory('TrainingDiscrepancyAdaptorFactory', TrainingDiscrepancyAdaptorFactory);
    
    function TrainingDiscrepancyAdaptorFactory() {
        var adaptSuggestedCrewList = function (response) {
            if(response.success){
                var typeCrew = _.sortBy(response.trainingRequiredCrews, 'crewType');
                return typeCrew;
            }
        };

        var createTrainingForAssign = function (training) {
            return {
                trainingSlotId: training.trainingSlotID,
                trainingSlotProramId:  training.trainingSlotProgramID || null,
                trainingProgramId:  training.trainingProgramID,
                trainingProgramDetailId: training.trainingProgDetailID,
                startDateZulu: training.toDateZulu,
                startTimeZulu: training.toTimeZulu
            };
        };

        return {
            adaptSuggestedCrewList: adaptSuggestedCrewList,
            createTrainingForAssign: createTrainingForAssign
        };
    }
})();